import { useQuery, useMutation, keepPreviousData } from '@tanstack/react-query';
import { createAgreement, deleteAgreement, getAgreement, getAgreements, restoreAgreement, updateAgreement } from '@/features/agreements/services/agreementsService';

const BASE = 'agreements';

export const agreementsQueryKeys = {
  base: () => [BASE],
  list: (data) => data ? [BASE, 'list', data] : [BASE, 'list'],
  detail: (id) => [BASE, 'detail', id],
};

export const useGetAgreements = (data, { enabled = true } = {}) => {
  return useQuery({
    queryKey: agreementsQueryKeys.list(data),
    placeholderData: keepPreviousData,
    queryFn: () => getAgreements(data),
    enabled: enabled,
  });
};

export const useGetAgreement = (id, { enabled = true } = {}) => {
  return useQuery({
    queryKey: agreementsQueryKeys.detail(id),
    queryFn: () => getAgreement(id),
    enabled: enabled && !!id,
  });
};

export const useCreateAgreement = () => {
  return useMutation({
    mutationFn: (data) => createAgreement(data),
  });
};

export const useUpdateAgreement = () => {
  return useMutation({
    mutationFn: ({ id, data }) => updateAgreement(id, data),
  });
};

export const useDeleteAgreement = () => {
  return useMutation({
    mutationFn: ({ id }) => deleteAgreement(id),
  });
};

export const useRestoreAgreement = () => {
  return useMutation({
    mutationFn: ({ id }) => restoreAgreement(id),
  });
};
